module.exports = __webpack_public_path__ + "media/sub2-6-7.f298928e.mp4";